import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./NavigationTags.module.css";

export interface NavigationTag {
    label: string;
    path?: string;
    isActive?: boolean;
}

export interface NavigationTagStyleClasses {
    container?: string;
    tag?: string;
    tagActive?: string;
    tagDisabled?: string;
    arrow?: string;
}

interface NavigationTagsProps {
    tags: NavigationTag[];
    className?: string;
    classes?: NavigationTagStyleClasses;
}

const NavigationTags: React.FC<NavigationTagsProps> = ({ tags, className = "", classes = {} }) => {
    const navigate = useNavigate();

    const containerClass = classes.container ?? styles.container;
    const tagClass = classes.tag ?? styles.tag;
    const tagActiveClass = classes.tagActive ?? styles.tagActive;
    const tagDisabledClass = classes.tagDisabled ?? styles.tagDisabled;
    const arrowClass = classes.arrow ?? styles.arrow;

    return (
        <div className={[containerClass, className].filter(Boolean).join(" ")}>
            {tags.map((tag, index) => (
                <React.Fragment key={index}>
                    {index > 0 && <span className={arrowClass}>→</span>}
                    <button
                        type="button"
                        className={[
                            tagClass,
                            tag.isActive ? tagActiveClass : "",
                            !tag.path && !tag.isActive ? tagDisabledClass : "",
                        ]
                            .filter(Boolean)
                            .join(" ")}
                        onClick={() => {
                            if (tag.path && !tag.isActive) {
                                navigate(tag.path);
                            }
                        }}
                        disabled={!tag.path && !tag.isActive}
                    >
                        {tag.label}
                    </button>
                </React.Fragment>
            ))}
        </div>
    );
};

export default NavigationTags;
